import React from 'react'
import {TextField, useTheme} from '@material-ui/core'

interface SearchProps {
	query: string;
    onQueryChange: (queru:string) => void;
    useThemeHook?: any;
}

export default function Search({query ,onQueryChange, useThemeHook = useTheme}: SearchProps) {
	const theme = useThemeHook()
	const spacing: number = theme.spacing()

	return (
		<div style={{paddingTop: `${spacing*2}px`, paddingBottom: `${spacing*2}px`}}>
			<TextField fullWidth id="outlined-search" size={'small'} label="Szukaj..." type="search" value={query}
				variant="outlined" onChange={e => onQueryChange(e.target.value) }/>
		</div>
	)
}